interface StepDotsProps {
  /** 1-based position within the flow. */
  current: number;
  total: number;
}

/**
 * Progress through onboarding.
 *
 * Counts the **adult path only** (screens 2, 3, 4, 7, 8) — five steps. A minor
 * additionally passes through parent phone and the waiting room, but those are
 * not extra steps to them: the dots would grow mid-flow and read as a penalty
 * for being under 18.
 */
export function StepDots({ current, total }: StepDotsProps) {
  return (
    <div
      className="flex items-center gap-1.5"
      role="img"
      aria-label={`Step ${current} of ${total}`}
    >
      {Array.from({ length: total }, (_, index) => {
        const isCurrent = index + 1 === current;
        return (
          <span
            key={index}
            className={`h-1.5 rounded-[var(--radius-chip)] transition-all ${
              isCurrent ? "w-[18px] bg-accent" : "w-1.5 bg-border-strong"
            }`}
          />
        );
      })}
    </div>
  );
}
